<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/R2ma2u/tc-custom/9780545685733.jpg?1700958117895" alt="This image is the cover for the book Woven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Woven
      </h1>
      <p class="bookDescription body article font2">
        <b>“It’s not often that you read a fantasy that feels as epic and original . . . Clever, well-paced, and full of intrigue, it’s a superb read.” —James Dashner, #1 <i>New York Times</i>–bestselling author</b><br/><br/>All his life, Nels has wanted to be a knight of the kingdom of Avërand. Tall and strong, and with a knack for helping those in need, the people of his sleepy little village have even taken to calling him the Knight of Cobblestown.<br/><br/>But that was before Nels died, murdered outside his home by a mysterious figure.<br/><br/>Now the young hero has awoken as a ghost, invisible to all around him save one person—his only hope for understanding what happened to him—the kingdom’s heir, Princess Tyra. At first the spoiled royal wants nothing to do with Nels, but as the mystery of his death unravels, the two find themselves linked by a secret, and an enemy who could be hiding behind any face.<br/><br/>Nels and Tyra have no choice but to abscond from the castle, charting a hidden world of tangled magic and forlorn phantoms. They must seek out an ancient needle with the power to mend what has been torn, and they have to move fast. Because soon Nels will disappear forever.<br/><br/><b>“<i>Woven</i> reads like a lost classic that was somehow just rediscovered. It has the feel of a comfortable, familiar blanket that’s somehow been newly-made of the brightest, most original material possible, and it is pure pleasure to read.” —James A. Owen, bestselling author &amp; illustrator of <i>Dawn of the Dragons</i></b><br/><br/><b>“This brisk adventure from first-time authors Jensen and King is a charming quest tale in classic fantasy tradition.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Jensen, David Powers King
      </h2>
      
      <p class="authorDescription body article"> Michael Jensen is the coauthor of WOVEN, with David Powers King. A graduate of Brigham Young University's prestigious music, dance, and theater program, Michael taught voice at BYU before establishing his own vocal instruction studio. In addition to being an imaginative storyteller, Michael is an accomplished composer and vocalist. He lives in Salt Lake City with his husband and their four dogs. <BR/> David Powers King is the coauthor of WOVEN, with Michael Jensen. David was born in beautiful downtown Burbank, California where his love for film inspired him to become a writer. An avid fan of science fiction and fantasy, David also has a soft spot for zombies and the paranormal. He now lives in the mountain West with his wife and three children. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b6c12a0